import React, { useEffect } from "react";
import { WebNavbar, Footer, ThemeSettings } from "./components";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as Pages from "./pages/index";
import { useStateContext } from "./contexts/ContextProvider";
import ProtectedContent from "./ProtectedContent";
import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  const {
    themeSettings,
    currentMode,
    isLoggedIn,
  } = useStateContext();

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  // Apply dark mode to document root
  useEffect(() => {
    if (currentMode === "Dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [currentMode]);

  return (
    <BrowserRouter>
      {isLoggedIn ? (
        <>
          {themeSettings && <ThemeSettings />}
          <ProtectedContent />
        </>
      ) : (
        <div className={`${currentMode === "Dark" ? "dark" : ""}`}>
          <div className="flex relative dark:bg-main-dark-bg">
            <div
              className={`dark:bg-main-dark-bg bg-main-bg min-h-screen w-full flex-2`}
            >
              <div>
                {themeSettings && <ThemeSettings />}
                <WebNavbar />
                <Routes>
                  <Route path="/" element={<Pages.Home />} />
                  <Route path='/review' element={<Pages.Review />} />
                  <Route path='/booking' element={<Pages.Booking />} />
                  <Route path="/login" element={<Pages.SignIn />} />
                  <Route path="/signup" element={<Pages.SignUp />} />
                  <Route path="/pricing" element={<Pages.Pricing />} />
                </Routes>
                <Footer />
              </div>
            </div>
          </div>
        </div>
      )}
    </BrowserRouter>
  );
};

export default App;
